import { Select, Tag, Typography } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import SupportStatus from "../../share/constants/support";

const statusColors = {
  [SupportStatus.PENDING]: 'error',
  [SupportStatus.RESOLVED]: 'success',
  [SupportStatus.CLOSED]: 'default'
};

const StatusDropdown = ({ value, onChange, variant = 'table' }) => {
  // Common props
  const baseProps = {
    value,
    onChange,
    dropdownMatchSelectWidth: false,
    suffixIcon: <CaretDownOutlined style={{ 
      color: variant === 'modal' ? 'rgba(0, 0, 0, 0.45)' : 'rgba(0, 0, 0, 0.25)' 
    }} />
  };

  if (variant === 'modal') {
    return (
      <div className="status-dropdown-container">
        <Typography.Title level={5} className="mt-1.5">
          Ticket Status
        </Typography.Title>

        <Select
          {...baseProps}
          className="w-[220px] bg-white rounded-md border border-gray-300 mt-0.5"
          dropdownStyle={{
            borderRadius: 8,
            padding: 8,
            minWidth: 250,
          }}
        >
          {Object.values(SupportStatus).map((status) => (
            <Select.Option key={status} value={status}>
              <Tag
                color={statusColors[status]}
                className="m-0 min-w-[80px] text-center"
              >
                {status}
              </Tag>
            </Select.Option>
          ))}
        </Select>

        <style jsx>{`
          .status-dropdown-container {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 16px;
          }
          .dropdown-label {
            font-size: 14px;
            color: #595959;
          }
        `}</style>
      </div>
    );
  }
  // Default table variant
  return (
    <Select
      {...baseProps}
      bordered={false}
      className="w-full bg-transparent"
      dropdownStyle={{ minWidth: 150 }}
    >
      {Object.values(SupportStatus).map((status) => (
        <Select.Option key={status} value={status}>
          <Tag color={statusColors[status]} className="m-0">
            {status}
          </Tag>
        </Select.Option>
      ))}
    </Select>
  );
};

export default StatusDropdown;
